export const Properties = {
		backendUrl: process.env.REACT_APP_CAPSIZED_BACKEND_URL || "http://localhost:8080",
		websocketsUrl: process.env.REACT_APP_CAPSIZED_WEBSOCKETS_URL || "ws://localhost:8080",
    sessionTimeoutMinutes: process.env.REACT_APP_SESSION_TIMEOUT_MINUTES || 30,
};